import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import Sidebar from "../../../components/Sidebar";
import Main from "./Main";

import { getDataWithComp, getAlert } from "../../../../utils/SamuiUtils";

const Tax = () => {
  const [dataMasterList, setDataMasterList] = useState([]);

  useEffect(() => {
    const fetchRealtime = async () => {
      try {
        const masterList = await getDataWithComp(
          "API_1701_WTAX_H",
          "ORDER BY WTAX_Id desc"
        );
        if (Array.isArray(masterList) && masterList.length > 0) {
          setDataMasterList(masterList);
        } else {
          setDataMasterList([]);
        }
      } catch (error) {
        getAlert("FAILED", error.message);
      }
    };

    fetchRealtime();
  }, []);

  return (
    <Box className="WithholdingTax" sx={{ display: "flex" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, ml: "var(--sidebar-width, 220px)", p: 3 }}
      >
        <Main name={"หนังสือหัก ณ ที่จ่าย"} dataMasterList={dataMasterList} />
      </Box>
    </Box>
  );
};

export default Tax;
